import { jsx as r, jsxs as c } from "react/jsx-runtime";
import h from "classnames";
import p, { keyframes as k } from "styled-components";
import { b as u } from "../../styled-qu50FBLM.mjs";
import { Svg as x, GElement as t, Circle as $, Path as E } from "./Elements.js";
const g = k`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, W = p(x)`
  animation: ${g} ${(e) => e.$duration ?? "1s"} linear infinite;
`, C = ({
  className: e = "",
  width: o = 105,
  height: i = 105,
  viewBox: a = "0 0 105 105",
  duration: s = "1s",
  d = "M45.5,1.42108547e-14 C20.3710439,1.42108547e-14 -3.55271368e-15,20.3710439 -3.55271368e-15,45.5",
  pathStroke: l = "#E3710A",
  circleStroke: m = "#E8E9E9",
  $cssHelper: f = u,
  focusable: n
}) => /* @__PURE__ */ r(
  W,
  {
    className: h({ [e]: !!e }),
    viewBox: a,
    width: `${o}px`,
    height: `${i}px`,
    $duration: s,
    $cssHelper: f,
    focusable: !!n,
    "aria-hidden": !n,
    children: /* @__PURE__ */ r(t, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(t, { transform: "translate(-42.000000, -1667.000000)", children: /* @__PURE__ */ r(t, { transform: "translate(40.000000, 1579.000000)", children: /* @__PURE__ */ r(t, { transform: "translate(2.000000, 88.000000)", children: /* @__PURE__ */ c(t, { transform: "translate(7.000000, 7.000000)", children: [
      /* @__PURE__ */ r(
        $,
        {
          stroke: m,
          strokeWidth: "14",
          cx: "45.5",
          cy: "45.5",
          r: "45.5"
        }
      ),
      /* @__PURE__ */ r(
        E,
        {
          d,
          stroke: l,
          strokeWidth: "14",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ] }) }) }) }) })
  }
);
export {
  C as default
};
